var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "amw-radio-wrap radio-label focus disBl",
      class: { NCAcmi_radio_off: _vm.disabled },
      style: { cursor: _vm.disabled ? "default" : "pointer" }
    },
    [
      _c("input", {
        staticClass: "amw-global-radio",
        attrs: {
          type: "radio",
          name: "activity-radio-" + _vm.unique,
          disabled: _vm.disabled
        },
        domProps: { value: _vm.example.se_code, checked: _vm.checked },
        on: { change: _vm.selectActivity }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "amw-radio-overlay" }),
      _vm._v(" "),
      _c("span", { staticClass: "amw-label-radio-text" }, [
        _vm._v("\n    " + _vm._s(_vm.displayText) + " "),
        _vm.example.remain_num !== null
          ? _c("em", [_vm._v("(잔여 " + _vm._s(_vm.example.remain_num) + ")")])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16c3a68b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c3a68b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/singapore/components/SurveyReturnScheduleExample.vue
// module id = null
// module chunks = 